module.exports = __webpack_public_path__ + "img/badge1.88c91f33.png";